export const statuses = {
  0: {
    name: 'Отзыв',
    title: 'Оставил отклик',
    field: 'created_at',
    history: [0],
    next: [2],
  },
  1: {
    name: 'Разгружен',
    title: 'Выгрузился',
    field: 'date_unloaded',
    history: [0, 2, 1],
    prev: 2,
    text: 'выгрузки',
  },
  2: {
    name: 'Погружен',
    title: 'Погрузился',
    field: 'date_loaded',
    history: [0, 2],
    next: [1, 3],
    prev: 0,
    text: 'погрузки',
  },
  3: {
    name: 'Возврат',
    title: 'Возврат',
    field: 'date_vozvrat',
    history: [0, 2, 3],
    prev: 2,
    text: 'возврата',
  },
}
